var _path, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchases({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 43L81.4154 45.6242C93.0396 47.3758 102.57 55.7552 105.794 67.0597L139.79 186.23C143.465 199.115 155.24 208 168.639 208H275.303C287.513 208 298.505 200.6 303.099 189.288L331.707 118.841C334.1 112.948 333.636 106.28 330.449 100.775V100.775C326.767 94.4157 319.975 90.5 312.627 90.5H146",
    stroke: "#EA3377",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 271,
    r: 26,
    stroke: "#EA3377",
    strokeWidth: 18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 267,
    cy: 271,
    r: 26,
    stroke: "#EA3377",
    strokeWidth: 18
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 149,
    r: 15,
    fill: "#FF3131"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 149,
    r: 15,
    fill: "#93E54B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 149,
    r: 15,
    fill: "#68ADE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchases);
export default __webpack_public_path__ + "static/media/purchases.67d24bbc47e8512cdedda44c66d3cd53.svg";
export { ForwardRef as ReactComponent };